export default "__VITE_ASSET__DdRALamO__"